/* import __COLOCATED_TEMPLATE__ from './article-views-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();